import { createFileRoute } from "@tanstack/react-router";
import EditCarListing from "@/pages/EditCarListing";
import SubscribedRoute from "@/components/shared/SubscribedRoute";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/edit-listing/$id/")({
  head: ({ params }) => routeHead("/edit-listing/$id/", params as Record<string, string>),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SubscribedRoute><EditCarListing /></SubscribedRoute>
  );
}
